module.exports = __webpack_public_path__ + "static/media/Home_DoOneIcon.a4babccf.png";